import React, { useEffect, useMemo, useState } from 'react'
import _ from 'lodash'
import classNames from 'classnames'
import { Icon } from '@qure/containers'
import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'

const Dropdown = props => {
  const {
    data,
    activeItem,
    onSelect,
    DropdownTrigger,
    isSearchable,
    height,
    searchPlaceholder
  } = props
  const [isActive, setActive] = useState(false)
  const [currentActiveItem, setCurrentActiveItem] = useState(
    _.get(activeItem, ['label'], '')
  )
  const [searchTerm, setSearchTerm] = useState('')
  const { t } = useTranslation()

  useEffect(() => {
    // setFirst dropdown item
    if (_.isEmpty(currentActiveItem) && !_.isEmpty(activeItem)) {
      setCurrentActiveItem(activeItem.label)
    }
  }, [activeItem])

  const onItemClick = datum => {
    setCurrentActiveItem(datum.label)
    if (onSelect) {
      onSelect(datum)
    }
    setActive(false)
  }

  const onToggleActive = () => {
    setActive(!isActive)
  }

  const onSearch = e => {
    const term = e.target.value
    setSearchTerm(term)
  }

  const dropdownData = useMemo(() => {
    if (searchTerm) {
      return data.filter(datum => {
        const label = _.get(datum, ['label'], '')
        return label.toLowerCase().search(searchTerm.toLowerCase()) >= 0
      })
    }
    return data
  }, [searchTerm, data])

  const dropDownClass = classNames('dropdown is-hoverable', {
    'is-active': isActive
  })

  return (
    <div className={dropDownClass}>
      <div
        className="dropdown-trigger"
        tabIndex={0}
        role="link"
        onClick={onToggleActive}
        onKeyDown={onToggleActive}
      >
        {DropdownTrigger && <DropdownTrigger />}
        {!DropdownTrigger && (
          <button
            type="button"
            className="button  is-outlined is-primary"
            aria-haspopup="true"
            aria-controls="dropdown-menu"
          >
            <span>{currentActiveItem}</span>
            {!isActive ? (
              <Icon iConClass="fa-angle-down" />
            ) : (
              <Icon iConClass="fa-angle-up" />
            )}
          </button>
        )}
      </div>
      <div className="dropdown-menu" id="dropdown-menu" role="menu">
        <div className="dropdown-content">
          {isSearchable && (
            <>
              <div className="dropdown-item">
                <div className="control has-icons-right">
                  <span className="icon is-small is-right">
                    <i className="fas fa-search" />
                  </span>
                  <input
                    type="text"
                    inputMode="search"
                    className="input"
                    value={searchTerm}
                    disabled={false}
                    onChange={onSearch}
                    placeholder={`${searchPlaceholder}...`}
                  />
                </div>
              </div>
              <div className="dropdown-divider" />
            </>
          )}
          <div style={{ maxHeight: height, overflowY: 'auto' }}>
            {dropdownData.map(datum => (
              /* eslint-disable */
              <a
                className={classNames('dropdown-item', {
                  'is-active': currentActiveItem === datum.label
                })}
                key={datum.label}
                onKeyDown={() => onItemClick(datum)}
                onClick={() => onItemClick(datum)}
              >
                {t(datum.label)}
              </a>
              /* eslint-enable */
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

Dropdown.defaultProps = {
  isSearchable: false,
  DropdownTrigger: null,
  height: '200px',
  searchPlaceholder: 'search',
  activeItem: {}
}

Dropdown.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    })
  ).isRequired,
  activeItem: PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  onSelect: PropTypes.func.isRequired,
  isSearchable: PropTypes.bool,
  DropdownTrigger: PropTypes.func,
  height: PropTypes.string,
  searchPlaceholder: PropTypes.string
}

export default Dropdown
